import PortalVue from 'portal-vue';

export default defineNuxtPlugin({
  name: 'portal-vue',
  setup(nuxtApp) {
    nuxtApp.vueApp.use(PortalVue);
  },
});
